import i18next from 'i18next'
import { realEstateGeneralFields } from '../../common/forms/generalRealEstate/fields'
import { Tab } from '../../types/global'

export const propertyGeneralFormTabs = (isEdit: boolean, hasServiceAndType: boolean): Tab[] => {
    const { t } = i18next

    const tabs = [
        { id: 1, name: 'general', label: t('app.common.generalInfo') },
        { id: 2, name: 'description', label: t('app.common.description'), disabled: !hasServiceAndType },
        { id: 3, name: 'map', label: t('form.common.tab.map'), disabled: !isEdit },
        {
            id: 4,
            name: 'materials',
            label: t('form.common.tab.materials'),
            disabled: !isEdit,
            children: [
                { id: '4-1', name: 'photos', label: t('app.common.photos') },
                { id: '4-2', name: 'groundPlans', label: t('app.common.groundPlans') },
                { id: '4-3', name: '3dVideo', label: t('form.common.tab.3dVideo') },
            ],
        },
        { id: 5, name: 'export', label: t('form.property.tab.export'), disabled: !isEdit },
        { id: 6, name: 'documents', label: t('app.common.documents'), disabled: !isEdit },
        { id: 7, name: 'transactions', label: t('form.property.tab.transactions'), disabled: !isEdit },
    ]

    return tabs
}

export const propertyViewTabs = (): Tab[] => {
    const { t } = i18next
    const tabs = [
        { id: 1, name: 'about', label: t('view.property.tab.about') },
        { id: 2, name: 'notes', label: t('app.common.notes') },
        { id: 6, name: 'documents', label: t('app.common.documents') },
        { id: 8, name: 'opportunity', label: t('app.common.opportunity') },
    ]
    
    return tabs
}

// fields to normalize for decimal number display
export const numeralInputFields = [
    realEstateGeneralFields.AREA,
    realEstateGeneralFields.AREA_NETT,
    realEstateGeneralFields.AREA_GARDEN,
    realEstateGeneralFields.AREA_STORAGE,
    realEstateGeneralFields.PLOT_AREA,
    realEstateGeneralFields.PLOT_WIDTH,
    realEstateGeneralFields.PLOT_LENGTH,
    realEstateGeneralFields.CONSTRUCTION_COEFFICIENT,
    realEstateGeneralFields.CONSTRUCTION_FLOORS_NO,
    realEstateGeneralFields.MAX_CONSTRUCTION_AREA,
    realEstateGeneralFields.CEILING_HEIGHT,
    realEstateGeneralFields.DISTANCE_SEA,
    realEstateGeneralFields.DISTANCE_RIVER,
    realEstateGeneralFields.DISTANCE_BEACH,
    realEstateGeneralFields.DISTANCE_CITY_CENTRE,
    realEstateGeneralFields.DISTANCE_SCHOOL,
    realEstateGeneralFields.DISTANCE_PUBLIC_TRANSPORTATION,
    realEstateGeneralFields.DISTANCE_PATHWAY,
]
